export default __webpack_public_path__ + "static/media/22.c398c4c5.png";